<p-fluid *transloco="let t; prefix: 'changePassword'">
  <form [formGroup]="form" (ngSubmit)="onSave()" class="flex flex-col gap-4">
    <div class="flex flex-col gap-2 mt-2">
      <label for="current-password" class="font-semibold">{{ t('currentPassword.label') }}</label>
      <p-password
        data-testid="current-password-input"
        id="current-password"
        placeholder="{{ t('currentPassword.label') }}"
        formControlName="currentPassword"
        [feedback]="false"
        [toggleMask]="true"
      />
    </div>
    <div class="flex flex-col gap-2 mt-2">
      <app-form-field
        id="password"
        fieldName="password"
        label="changePassword.newPassword.label"
        type="password"
      ></app-form-field>
    </div>
    <div class="flex flex-col gap-2 mt-2">
      <app-form-field
        id="passwordRepeat"
        fieldName="passwordRepeat"
        label="account.register.passwordRepeat"
        type="passwordRepeat"
      ></app-form-field>
    </div>
    <div class="flex justify-end gap-2 mt-3.5">
      <p-button
        label="{{ 'common.cancel' | transloco }}"
        severity="secondary"
        (onClick)="onHideDialog()"
      />
      <p-button label="{{ 'common.save' | transloco }}" type="submit" [loading]="submitting" />
    </div>
  </form>
</p-fluid>
